"use client";

import "react-vertical-timeline-component/style.min.css";
import { VerticalTimeline } from "react-vertical-timeline-component";
import { cn } from "@/lib/cn";
import { experienceList } from "@/utils/render";
import { EXPERIENCE_PER_PAGE, MAIN_COLOR } from "@/utils/constants";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useTranslations } from "next-intl";
import { TExperience } from "./Experience";
import ExperienceItem from "./ExperienceItem";
import { useDeviceType } from "@/hooks/useDeviceType";

const ExperienceList = ({ lang, experience }: TExperience) => {
  const t = useTranslations();
  const [visibleItems, setVisibleItems] = useState(EXPERIENCE_PER_PAGE);
  const deviceType = useDeviceType();

  const handleShowMore = () => {
    setVisibleItems(
      (prevVisibleItems) => prevVisibleItems + EXPERIENCE_PER_PAGE
    );
  };

  return (
    <div>
      <VerticalTimeline
        className="max-w-none! m-0! w-full!"
        animate={deviceType !== "mobile"}
        lineColor={MAIN_COLOR}
        layout={cn(lang === "ar" ? "1-column-right" : "1-column-left")}
      >
        {experience?.slice(0, visibleItems).map((item) => (
          <ExperienceItem lang={lang} key={item?._id} {...item} />
        ))}
      </VerticalTimeline>

      {visibleItems < experienceList.length && (
        <div className="flex justify-center mt-4">
          <Button aria-label={t("Load More")} onClick={handleShowMore}>
            {t("Load More")}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ExperienceList;
